import * as Sentry from '@sentry/vue'
import { type App } from 'vue'

export const sentryInit = (app: App<Element>) => {
  Sentry.init({
    environment: import.meta.env.VITE_OUTPUT_ENVIRONMENT,
    app,
    dsn: 'https://b9341ed8796725c6bc5181f1ad375a76@o1114978.ingest.us.sentry.io/4506420456128512'
  })
}

export const sentryCapture = (err: any) => {
  Sentry.captureException(err)
}
